import { BaseService } from '@services/BaseService';
import { OptionsViewModel, PageViewModel } from '@models/common.models';
import { DocumentViewModel, FileViewModel } from '@models/Document';
import { DocumentHistoryViewModel } from '@models/DocumentHistory';

class DocumentService extends BaseService {
  constructor() {
    super('document');
  }

  saveFiles(
    fileVMs: FileViewModel[],
    customerId?: number,
    contractId?: number,
    purchaseRequestId?: number,
    invoiceId?: number,
    vendorId?: number
  ) {
    const formData = new FormData();
    var edocsTypeIds = '';
    var documentTypeIds = '';
    for (const fileVM of fileVMs) {
      formData.append('files', fileVM.file, fileVM.file.name);
      var edocsTypeId = fileVM.edocsTypeId ? fileVM.edocsTypeId : 0;
      edocsTypeIds += `edocsTypeIds=${edocsTypeId}&`;
      var documentType = fileVM.documentTypeId ? fileVM.documentTypeId : 0;
      documentTypeIds += `documentTypeIds=${documentType}&`;
    }
    let queryString = '';
    if (customerId) {
      queryString = `customerId=${customerId}`;
    }
    if (queryString.length > 0 && contractId) {
      queryString += '&';
    }
    if (contractId) {
      queryString += `contractId=${contractId}`;
    }
    if (queryString.length > 0 && purchaseRequestId) {
      queryString += '&';
    }
    if (purchaseRequestId) {
      queryString += `purchaseRequestId=${purchaseRequestId}`;
    }
    if (invoiceId) {
      queryString += `invoiceId=${invoiceId}`;
    }
    if (vendorId) {
      queryString += `vendorId=${vendorId}`;
    }
    if (queryString.length > 0 && vendorId) {
      queryString += '&';
    }
    if (queryString.length > 0 && edocsTypeIds.length > 0) {
      queryString += '&';
    }
    if (edocsTypeIds.length > 0) {
      queryString += edocsTypeIds.substring(0, edocsTypeIds.length - 1);
    }
    if (queryString.length > 0 && documentTypeIds.length > 0) {
      queryString += '&';
    }
    if (documentTypeIds.length > 0) {
      queryString += documentTypeIds.substring(0, documentTypeIds.length - 1);
    }
    return this.fetch<DocumentViewModel[]>(
      'upload_multiple?' + queryString,
      {
        method: 'POST',
        body: formData
      },
      false,
      false,
      true
    );
  }

  removeFile(fileId: number) {
    return this.fetch(`${fileId}`, {
      method: 'DELETE'
    });
  }

  getContractFiles(contractId: number) {
    var timeNow = Date.now().toString();
    return this.fetch<DocumentViewModel[]>(`?contractId=${contractId}&time=${timeNow}`, {
      method: 'GET'
    });
  }

  getInvoiceFiles(invoiceId: number) {
    return this.fetch<DocumentViewModel[]>(`Invoicing?invoiceId=${invoiceId}`, {
      method: 'GET'
    });
  }

  getVendorFiles(vendorId: number) {
    var timeNow = Date.now().toString();
    return this.fetch<DocumentViewModel[]>(`Vendors?vendorId=${vendorId}&time=${timeNow}`, {
      method: 'GET'
    });
  }

  getEdocTypes() {
    return this.fetch<OptionsViewModel[]>('EdocsType', {
      method: 'GET'
    });
  }

  getPurchaseRequestFiles(purchaseRequestId: number) {
    // var timeNow = Date.now().toString();
    return this.fetch<DocumentViewModel[]>(`PurchaseRequests?purchaseRequestId=${purchaseRequestId}`, {
      // &time=${timeNow}`, {
      method: 'GET'
    });
  }

  resendDocument(id: number, entityId?: number, email?: string) {
    const entityString = entityId === undefined ? '' : `?entityId=` + entityId;
    const emailString = email === undefined ? '' : `&email=` + email;
    return this.fetch(`${id}/resend${entityString}${emailString}`, {
      method: 'POST'
    });
  }

  getFailedEmails(
    pageNumber: number,
    pageSize: number,
    orderBy: string,
    orderByDirection: string,
    query?: string
  ): Promise<PageViewModel<DocumentHistoryViewModel>> {
    let queryParameters = [];
    // paging
    queryParameters.push(`pageNumber=${Math.max(1, pageNumber)}`);
    queryParameters.push(`pageSize=${Math.max(0, pageSize)}`);
    // sorting
    if (orderBy) {
      queryParameters.push(`orderBy=${encodeURIComponent(orderBy)}`);
    }
    if (orderByDirection) {
      queryParameters.push(`orderByDirection=${encodeURIComponent(orderByDirection)}`);
    }

    if (query) {
      queryParameters.push(`query=${query}`);
    }

    const uri: string = 'failed-emails'.concat(queryParameters.length > 0 ? '?' : '', queryParameters.join('&'));

    return this.fetch<PageViewModel<DocumentHistoryViewModel>>(uri, {
      method: 'GET'
    });
  }

  ownFailedEmail(emailHistoryId: number) {
    const uri: string = `failed-emails/${emailHistoryId}/own`;
    return this.fetch<DocumentHistoryViewModel>(uri, {
      method: 'POST'
    });
  }

  releaseFailedEmail(emailHistoryId: number) {
    const uri: string = `failed-emails/${emailHistoryId}/release`;
    return this.fetch<DocumentHistoryViewModel>(uri, {
      method: 'POST'
    });
  }

  removeFailedEmail(emailHistoryId: number) {
    const uri: string = `failed-emails/${emailHistoryId}/remove`;
    return this.fetch(uri, {
      method: 'POST'
    });
  }
}

export const documentService = new DocumentService();



// WEBPACK FOOTER //
// ./src/_services/DocumentService.ts